import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import { roundNumber, copy, isEmpty } from './functions.js';
// import "ie-array-find-polyfill";

class ResizeImagePreviewLayer extends React.Component {

    layerSymbolMinHeight = 0;
    layerSymbolMinWidth = 0;

    constructor(props) {
        super(props);

        const loaderStyle = {
            width: this.props.contentLayer.dimensions.width + 'px', 
            height: this.props.contentLayer.dimensions.height + 'px',
            lineHeight: this.props.contentLayer.dimensions.height + 'px'
        };

        this.state = {
            height: this.props.contentLayer.dimensions.height,
            width: this.props.contentLayer.dimensions.width,
            contentLayer: copy(this.props.contentLayer),
            symbolCanRoate: -1,
            symbolNeedsRotation: -1,
            checkMinWidth: -1,
            activeDesignerVariants: this.props.activeDesignerVariants,
            aspectRatio: null,
        }

        this.setLayerSymbolMinSize(this.props.contentLayer);

        this.handleSymbolRemove = this.handleSymbolRemove.bind(this);
        this.handleSymbolFlip = this.handleSymbolFlip.bind(this);
        this.handleLayerSelect = this.handleLayerSelect.bind(this);
        this.handleLayerMove = this.handleLayerMove.bind(this);
        this.handleLayerMoveEnd = this.handleLayerMoveEnd.bind(this);
        this.handleLayerResize = this.handleLayerResize.bind(this);
        this.handleLayerResizeEnd = this.handleLayerResizeEnd.bind(this);
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageErrored = this.handleImageErrored.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);

        this.imageRotateSvgTransform = null;
        this.imageRotateCenterX = 0;
        this.imageRotateCenterY = 0;
        this.imageRotateViewboxX = 0;
        this.imageRotateViewboxY = 0;
        this.imageRotateViewboxOrgX = 0;
        this.imageRotateViewboxOrgY = 0;
    }


    getImageElements(){
        let imgElements = this.symbolPreviewLayer.getElementsByTagName("img");
        if (imgElements === undefined || imgElements === null || imgElements.length <= 0)
            this.symbolPreviewLayer.getElementsByTagName("IMG");

        return imgElements;
    }

    handleSymbolFlip(e) {
        e.preventDefault();
        const layer = this.props.contentLayer;
        layer.symbolFlip = !layer.symbolFlip;
        this.props.onContentLayerChange(layer);
    }

    handleSymbolRemove(e) {
        this.props.onContentLayerRemove(this.props.contentLayer);
    }

    handleLayerSelect(e) {
        this.props.onContentLayerSelect(this.props.layerIndex);
    }

    handleLayerResize(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;
        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;
        
        this.setState({
            contentLayer: layer,
            height: layer.dimensions.height,
            width: layer.dimensions.width
        })
    }

    handleLayerResizeEnd(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;
        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;
        
        this.props.onContentLayerChange(layer);
    }

    handleLayerMove(e, data) {

        const layer = this.state.contentLayer;

        const layerMaxBounds = {
            posY: layer.maxDimensions.posY,
            posX: layer.maxDimensions.posX,
            width: layer.maxDimensions.width,
            height: layer.maxDimensions.height,
        }

        if (this.state.contentLayer.hasOverlay)
        {
            layerMaxBounds.posY = 0;
            layerMaxBounds.posX = 0;
            layerMaxBounds.width = 890;
            layerMaxBounds.height = 890;
        }

        if (data.y >= 0 && data.y <= layerMaxBounds.height - layer.dimensions.height)
            layer.dimensions.posY = data.y;

        if (data.x >= 0 && data.x <= layerMaxBounds.width - layer.dimensions.width)
            layer.dimensions.posX = data.x;

        if ((data.y >= 0 && data.y <= layerMaxBounds.height - layer.dimensions.height)||
            (data.x >= 0 && data.x <= layerMaxBounds.width - layer.dimensions.width))
        {
            this.setState({
                contentLayer: layer
            })
        }
        else if (this.rnd !== null && this.rnd !== undefined)
        {
            this.rnd.updatePosition({ x: this.props.contentLayer.dimensions.posX, y: this.props.contentLayer.dimensions.posY });
            this.rnd.updateSize({ width: this.props.contentLayer.dimensions.width, height: this.props.contentLayer.dimensions.height });
        }
    }

    handleLayerMoveEnd(e, data) {

        const layer = this.state.contentLayer;

        const layerMaxBounds = {
            posY: layer.maxDimensions.posY,
            posX: layer.maxDimensions.posX,
            width: layer.maxDimensions.width,
            height: layer.maxDimensions.height,
        }

        if (this.state.contentLayer.hasOverlay)
        {
            layerMaxBounds.posY = 0;
            layerMaxBounds.posX = 0;
            layerMaxBounds.width = 890;
            layerMaxBounds.height = 890;
        }

        if ((data.y < 0 || data.y > layerMaxBounds.height - layer.dimensions.height) ||
            (data.x < 0 && data.x > layerMaxBounds.width - layer.dimensions.width))
        {
            if (this.rnd !== null && this.rnd !== undefined)
            {
                this.rnd.updatePosition({ x: this.props.contentLayer.dimensions.posX, y: this.props.contentLayer.dimensions.posY });
                this.rnd.updateSize({ width: this.props.contentLayer.dimensions.width, height: this.props.contentLayer.dimensions.height });
            }

            this.setState({
                contentLayer: this.props.contentLayer
            })
        }
        else
        {
            layer.dimensions.posY = data.y;
            layer.dimensions.posX = data.x;

            this.props.onContentLayerChange(layer);
        }
    }

    componentDidMount() {
        const imageElements = this.getImageElements();

        if (imageElements !== undefined && imageElements !== null & imageElements.length >= 1) {
            // set image size
            if (imageElements[0].style != this.state.width || imageElements[0].style.height != this.state.height + 'px') {
                imageElements[0].style.width = this.state.width + 'px';
                imageElements[0].style.height = this.state.height + 'px';
            }
        }
    }

    componentDidUpdate() {

        const imageElements = this.getImageElements();

        if (imageElements !== undefined && imageElements !== null & imageElements.length >= 1)
        {
            // set image size
            if (imageElements[0].style != this.state.width || imageElements[0].style.height != this.state.height + 'px')
            {
                imageElements[0].style.width = this.state.width + 'px';
                imageElements[0].style.height = this.state.height + 'px';
            }

            // handle min size
            const newLayer = copy(this.props.contentLayer);
            if (this.layerSymbolMinWidth > newLayer.dimensions.width || this.layerSymbolMinHeight > newLayer.dimensions.height)
            {
                if (this.layerSymbolMinWidth > newLayer.dimensions.width)
                {
                    if (newLayer.dimensions.posX + this.layerSymbolMinWidth > newLayer.maxDimensions.posX + newLayer.maxDimensions.width)
                    {
                        newLayer.dimensions.posX = newLayer.dimensions.posX - (this.layerSymbolMinWidth - newLayer.dimensions.width);
                    }
                    newLayer.dimensions.width = this.layerSymbolMinWidth;
                    imageElements[0].style.width = this.layerSymbolMinWidth + 'px';
                }

                if (this.layerSymbolMinHeight > newLayer.dimensions.height)
                {
                    if (newLayer.dimensions.posY + this.layerSymbolMinHeight > newLayer.maxDimensions.posY + newLayer.maxDimensions.height)
                    {
                        newLayer.dimensions.posY = newLayer.dimensions.posY - (this.layerSymbolMinHeight - newLayer.dimensions.height);
                    }

                    newLayer.dimensions.height = this.layerSymbolMinHeight;
                    imageElements[0].style.height = this.layerSymbolMinHeight + 'px';
                }

                if (this.rnd !== null && this.rnd !== undefined)
                {
                    this.rnd.updatePosition({ x: newLayer.dimensions.posX, y: newLayer.dimensions.posY });
                    this.rnd.updateSize({ width: newLayer.dimensions.width, height: newLayer.dimensions.height });
                }                

                this.props.onContentLayerChange(newLayer);
                
                this.setState({
                    width: newLayer.dimensions.width,
                    height: newLayer.dimensions.height,
                    contentLayer: newLayer,
                });
            }

            if (this.props.hasOverlay != this.state.contentLayer.hasOverlay)
            {
                newLayer.hasOverlay = this.props.hasOverlay;

                if (this.props.hasOverlay)
                {
                    newLayer.dimensions.posX += newLayer.maxDimensions.posX;
                    newLayer.dimensions.posY += newLayer.maxDimensions.posY;
                }
                else
                {
                    newLayer.dimensions.posX -= newLayer.maxDimensions.posX;
                    newLayer.dimensions.posY -= newLayer.maxDimensions.posY;

                    // landscape
                    if (newLayer.dimensions.width >= newLayer.dimensions.height)
                    {
                        if (newLayer.dimensions.width > newLayer.maxDimensions.width)
                        {
                            newLayer.dimensions.width = newLayer.maxDimensions.width;
                            newLayer.dimensions.height = newLayer.dimensions.width / newLayer.aspectRatio;
                        }

                        if (newLayer.dimensions.height > newLayer.maxDimensions.height)
                        {
                            newLayer.dimensions.height = newLayer.maxDimensions.height;
                            newLayer.dimensions.width = newLayer.dimensions.height * newLayer.aspectRatio;
                        }
                    }
                    // portrait
                    else
                    {
                        if (newLayer.dimensions.height > newLayer.maxDimensions.height)
                        {
                            newLayer.dimensions.height = newLayer.maxDimensions.height;
                            newLayer.dimensions.width = newLayer.dimensions.height / newLayer.aspectRatio;
                        }

                        if (newLayer.dimensions.width > newLayer.maxDimensions.width)
                        {
                            newLayer.dimensions.width = newLayer.maxDimensions.width;
                            newLayer.dimensions.height = newLayer.dimensions.width * newLayer.aspectRatio;
                        }
                    }

                    if (newLayer.dimensions.posX < 0 || newLayer.dimensions.posX + newLayer.dimensions.width > newLayer.maxDimensions.width)
                        newLayer.dimensions.posX = 0;

                    if (newLayer.dimensions.posY < 0 || newLayer.dimensions.posY + newLayer.dimensions.height > newLayer.maxDimensions.height)
                        newLayer.dimensions.posY = 0;

                }

                if (this.rnd !== null && this.rnd !== undefined)
                {
                    this.rnd.updatePosition({ x: newLayer.dimensions.posX, y: newLayer.dimensions.posY });
                    this.rnd.updateSize({ width: newLayer.dimensions.width, height: newLayer.dimensions.height });
                }

                this.props.onContentLayerChange(newLayer);

                this.setState({
                    width: newLayer.dimensions.width,
                    height: newLayer.dimensions.height,
                    contentLayer: newLayer,
                });
            }
        }

        if (this.state.activeDesignerVariants != this.props.activeDesignerVariants)
        {
            this.setState({
                activeDesignerVariants: this.props.activeDesignerVariants,
                checkMinWidth: 1
            });
        }

        if (this.state.checkMinWidth === 1)
        {
            this.setLayerSymbolMinSize(this.props.contentLayer);
            this.setState({
                checkMinWidth: -1,
            });
        }

    }

    getExportHeightInMm(contentLayer) {
        
        let exportHeightInMm = contentLayer.exportHeightMm;
        const exportSizeVar = this.props.activeDesignerVariants.find(desvar => {
            return desvar.isExportSize == "1";
        });

        if (exportSizeVar !== null && exportSizeVar !== undefined && exportSizeVar.selectedVar !== null && exportSizeVar.selectedVar.export_sizes.length > 0)
        {
            const exportSize = exportSizeVar.selectedVar.export_sizes.find(es => {
                return es.perspective_id == this.props.activePerspective.id;
            });

            if (exportSize !== null && exportSize !== undefined)
            {
                const varExportWidthInMm = parseFloat(exportSize.export_width_mm);
                if (varExportWidthInMm > 0)
                {
                    exportHeightInMm = parseFloat(varExportWidthInMm * this.state.contentLayer.maxDimensions.height / this.state.contentLayer.maxDimensions.width);
                }
            }
        }

        return exportHeightInMm;
    }
    
    getExportWidthInMm(contentLayer) {
        
        let exportWidthInMm = contentLayer.exportWidthMm;
        const exportSizeVar = this.props.activeDesignerVariants.find(desvar => {
            return desvar.isExportSize == "1";
        });

        if (exportSizeVar !== null && exportSizeVar !== undefined && exportSizeVar.selectedVar !== null && exportSizeVar.selectedVar.export_sizes.length > 0)
        {
            const exportSize = exportSizeVar.selectedVar.export_sizes.find(es => {
                return es.perspective_id == this.props.activePerspective.id;
            });

            if (exportSize !== null && exportSize !== undefined)
            {
                return parseFloat(exportSize.export_width_mm);
            }
        }

        return exportWidthInMm;
    }

    setLayerSymbolMinSize(contentLayer) {

        const exportHeightInMm = this.getExportHeightInMm(contentLayer);
        const exportWidthInMm = this.getExportWidthInMm(contentLayer);

        let exportSizeInMm = exportHeightInMm;
        let exportSizeInPx = contentLayer.maxDimensions.height;

        if (exportWidthInMm < exportSizeInMm)
        {
            exportSizeInMm = exportWidthInMm;
            exportSizeInPx = contentLayer.maxDimensions.width;
        }

        let minSymSizeInMm = 15;
        if (minSymSizeInMm < exportSizeInMm / 5)
            minSymSizeInMm = exportSizeInMm / 5

        if (minSymSizeInMm > 40)
            minSymSizeInMm = 40;


        let minSizePx = exportSizeInPx * minSymSizeInMm / exportSizeInMm;
        if (isNaN(minSizePx) || !isFinite(minSizePx)) 
            minSizePx = 30;

        this.layerSymbolMinWidth = minSizePx;
        this.layerSymbolMinHeight = minSizePx;
    }

    isLayerVisible() {
        if (this.props.activePerspective.id != this.state.contentLayer.perspectiveId || 
            this.props.activePerspective.varid != this.state.contentLayer.perspective_varid || 
            this.state.contentLayer.content === '' || 
            this.state.contentLayer.content === null)
            return false;

        return true;
    }

    getLayerZIndex() {
        return (100 - (this.props.layerIndex * 2));
    }

    handleImageLoaded(event) {

        if (this.state.contentLayer !== undefined && this.state.contentLayer.aspectRatio !== undefined)
            return;

        // resize image
        let image = this.getImageElements();
        if (image.length == 1)
            image = image[0];
        else
            return;

        let aspectRatio = image.naturalWidth / image.naturalHeight;
        let width = this.state.contentLayer.maxDimensions.width;
        let height = this.state.contentLayer.maxDimensions.width / aspectRatio;

        if (image.naturalHeight > image.naturalWidth)
        {
            aspectRatio = image.naturalHeight / image.naturalWidth
            height = this.state.contentLayer.maxDimensions.height;
            width = this.state.contentLayer.maxDimensions.height / aspectRatio;
        }

        const layer = this.state.contentLayer;
        layer.dimensions.height = height;
        layer.dimensions.width = width;
        layer.aspectRatio = aspectRatio;

        if (this.props.hasOverlay)
        {
            layer.dimensions.posX += layer.maxDimensions.posX;
            layer.dimensions.posY += layer.maxDimensions.posY;
            layer.hasOverlay = true;
        }
        else
            layer.hasOverlay = false;

        this.setState({
            contentLayer: layer,
            height: layer.dimensions.height,
            width: layer.dimensions.width,
            aspectRatio: aspectRatio,
        }, function(){
            this.props.onContentLayerChange(layer);
            if (this.rnd !== null && this.rnd !== undefined)
            {
                this.rnd.updateSize({ width: width, height: height });
                this.rnd.updatePosition({ x: layer.dimensions.posX, y: layer.dimensions.posY });
            }
        })

        // this.setState({ imageStatus: "loaded" });
    }

    handleImageErrored(event) {
        // this.setState({ imageStatus: "failed to load" });
    }

    handleMouseEnter(e) {
        e.preventDefault();

        this.props.onMouseEnter(this.state.contentLayer);
    }

    handleMouseLeave(e) {
        e.preventDefault();

        this.props.onMouseLeave(this.state.contentLayer);
    }

    render() {

        const layerPositionStyle = {
            top: this.state.contentLayer.dimensions.posY.toString() + 'px',
            left: this.state.contentLayer.dimensions.posX.toString()  + 'px',
            zIndex: this.getLayerZIndex()
        }; 

        const layerActiveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: '0px',
            left: '0px'
        };

        const layerMaxBounds = {
            top: this.state.contentLayer.maxDimensions.posY.toString() + 'px',
            left: this.state.contentLayer.maxDimensions.posX.toString() + 'px',
            width: this.state.contentLayer.maxDimensions.width.toString() + 'px',
            height: this.state.contentLayer.maxDimensions.height.toString() + 'px',
        }

        if (this.state.contentLayer.hasOverlay)
        {
            layerMaxBounds.top = '0px';
            layerMaxBounds.left = '0px';
            layerMaxBounds.width = '890px';
            layerMaxBounds.height = '890px';
        }

        let layerMoveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: this.state.contentLayer.dimensions.posX,
            left: this.state.contentLayer.dimensions.posY,
            zIndex: this.getLayerZIndex()
        }

        return (
            <div className={"preview_layer layer_max_bounds " + (this.props.contentLayer.symbolFlip ? ' symbol_flip' : '')} style={layerMaxBounds}>
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className="layer_resize_wrapper" ref={ (layerResizeWrapper) => this.layerResizeWrapper = layerResizeWrapper}>
                        <div className="layer_rotate_wrapper">
                            <div className='image_preview_layer' ref={ (s) => this.symbolPreviewLayer = s}>
                                <img
                                    src={this.state.contentLayer.content.imageBaseUrl + this.state.contentLayer.content.file}
                                    onLoad={this.handleImageLoaded}
                                    onError={this.handleImageErrored}
                                    alt="Bild"/>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    // Render if props.designerRenderMode is 'designer'
                    this.props.designerRenderMode == 'designer' ? 
                    <Rnd
                        style={{ background: 'transparent', zIndex: layerMoveStyle.zIndex }}
                        default={{
                            x: layerMoveStyle.top,
                            y: layerMoveStyle.left,
                            width: layerMoveStyle.width,
                            height: layerMoveStyle.height
                        }}
                        ref={c => { this.rnd = c; }}
                        minHeight={this.layerSymbolMinHeight}
                        minWidth={this.layerSymbolMinWidth}
                        className={"layer_rnd_wrapper" + (this.props.isActiveLayer ? ' active' : '')}
                        resizeHandleClasses={{ bottomRight: 'layer_handle layer_resize_handle fa fa-expand fa-flip-horizontal'}}
                        onDrag={this.handleLayerMove}
                        onDragStop={this.handleLayerMoveEnd}
                        onResize={this.handleLayerResize}
                        onResizeStop={this.handleLayerResizeEnd}
                        bounds={'parent'}
                        lockAspectRatio={true}
                        scale={this.props.responsiveScale}
                        dragHandleClassName='layer_active_wrapper'
                        enableResizing={{ top:false, right:false, bottom:false, left:false, topRight:false, bottomRight:true, bottomLeft:false, topLeft:false }}
                    >
                        <div className={"layer_active_wrapper" + (this.props.isActiveLayer ? ' active' : '')}
                             style={layerActiveStyle}
                             onMouseDown={this.handleLayerSelect}
                             onMouseEnter={this.handleMouseEnter}
                             onMouseLeave={this.handleMouseLeave}
                        >
                        </div>
                        <div className="layer_handle layer_flip_handle" onClick={this.handleSymbolFlip}> <FontAwesome name='star-half-o' className='layer_handle_icon' /> </div>
                        <div className="layer_handle layer_remove_handle" onClick={this.handleSymbolRemove}> <FontAwesome name='trash' className='layer_handle_icon'/> </div>
                    </Rnd>
                    : null
                }


            </div>
        );
    }
  }

export default ResizeImagePreviewLayer;




// WEBPACK FOOTER //
// ./src/ResizeImagePreviewLayer.js